/**
 * Payment Design Tokens
 * Figma design system colors and styles for mobile payment components
 * Based on Figma designs: https://www.figma.com/design/5JJxK95E3SWdTaU7EfcuFZ/Resio---Web-portal
 */

export const PAYMENT_DESIGN_TOKENS = {
  // Background colors
  BACKGROUND: '#171717',
  CARD_BACKGROUND: '#2F2F2F',
  CARD_BACKGROUND_SECONDARY: '#242424',

  // Text colors
  TEXT_PRIMARY: '#EEF1F4',
  TEXT_MUTED: '#919191',
  TEXT_SECONDARY: '#ACACAC',
  TEXT_TERTIARY: '#464646',

  // Accent colors
  SUCCESS_GREEN: '#5CBC5D',
  PINK_ACCENT: '#F55560',
  BLUE_LINK: '#6B8EFE',
  ERROR_RED: '#F55560',

  // Border colors
  BORDER: '#464646',
  BORDER_LIGHT: '#3F3F3F',

  // Badge colors
  BADGE_PINK_BG: 'rgba(245, 85, 96, 0.15)',
  BADGE_PINK_TEXT: '#F55560',
  BADGE_GREEN_BG: 'rgba(92, 188, 93, 0.15)',
  BADGE_GREEN_TEXT: '#5CBC5D',

  // Button colors
  BUTTON_PRIMARY: '#F55560',
  BUTTON_PRIMARY_TEXT: '#EEF1F4',
  BUTTON_SECONDARY: '#6B8EFE',
  BUTTON_SECONDARY_TEXT: '#EEF1F4',
  BUTTON_OUTLINE_BORDER: '#464646',
  BUTTON_OUTLINE_TEXT: '#EEF1F4',

  // Avatar
  AVATAR_BACKGROUND: '#464646',
  AVATAR_TEXT: '#EEF1F4',

  // Gradient border (for card)
  GRADIENT_START: '#F55560',
  GRADIENT_END: '#6B8EFE',

  // Overlay
  OVERLAY_BACKGROUND: 'rgba(0, 0, 0, 0.75)',

  // Table
  TABLE_HEADER_TEXT: '#919191',
  TABLE_ROW_BORDER: '#464646',
  TABLE_AMOUNT_POSITIVE: '#5CBC5D',
  TABLE_AMOUNT_NEGATIVE: '#F55560',
  TABLE_AMOUNT_NEUTRAL: '#EEF1F4',
} as const;

// Typography styles matching Figma
export const PAYMENT_TYPOGRAPHY = {
  // Headings
  heading2xl: {
    fontSize: 24,
    fontWeight: '700' as const,
    lineHeight: 36,
  },
  headingLg: {
    fontSize: 18,
    fontWeight: '600' as const,
    lineHeight: 27,
  },
  headingMd: {
    fontSize: 16,
    fontWeight: '600' as const,
    lineHeight: 24,
  },

  // Body text
  bodySm: {
    fontSize: 14,
    fontWeight: '400' as const,
    lineHeight: 21,
  },
  bodySmMedium: {
    fontSize: 14,
    fontWeight: '500' as const,
    lineHeight: 21,
  },
  bodySmSemiBold: {
    fontSize: 14,
    fontWeight: '600' as const,
    lineHeight: 21,
  },

  // Small text
  textXs: {
    fontSize: 12,
    fontWeight: '400' as const,
    lineHeight: 18,
  },
  textXsMedium: {
    fontSize: 12,
    fontWeight: '500' as const,
    lineHeight: 18,
  },
  textXsLight: {
    fontSize: 12,
    fontWeight: '300' as const,
    lineHeight: 18,
  },
} as const;

// Spacing values
export const PAYMENT_SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
  xxxl: 32,
} as const;

// Border radius values
export const PAYMENT_BORDER_RADIUS = {
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  xxl: 24,
  full: 9999,
} as const;

// Avatar sizes
export const PAYMENT_AVATAR_SIZE = {
  sm: 40,
  md: 56,
  lg: 68,
} as const;
